import HeaderFilter from '../../../components/HeaderFilter';
import LocationForm from './LocationForm';
import LocationTable from './LocationTable';

const LocationPage = () => {
  const api = '/location/locations';
  return (
    <>
      <div className={'page-wrapper'}>
        <HeaderFilter />
        <LocationForm api={api} />
        <LocationTable api={api} />
      </div>
    </>
  );
};

export default LocationPage;
